import { Coord } from "../../types/Interface";

export default function getAngleBetweenPoints(cStart: Coord, cEnd: Coord): number {
  return Number(Math.atan2(cEnd.y - cStart.y, cEnd.x - cStart.x).toFixed(4));
}